import React, { ReactNode } from "react";

import css from "./saml_config_field.module.scss";

type SamlConfigFieldProps = {
  label: string;
  children: ReactNode;
};

const SamlConfigField = ({ label, children }: SamlConfigFieldProps): JSX.Element => (
  <div className={css.lineWrapper}>
    <div className={css.left}>{label}</div>
    <div className={css.right}>{children}</div>
  </div>
);

export default SamlConfigField;
